import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { getSubjects, subjectSelectors } from "./subjectsSlice"
import { getStudios, studioSelectors } from "./studiosSlice"
import { getGroups, groupSelectors } from "./groupsSlice"
import { getStudents, studentSelectors } from "./studentsSlice"
import { getParents, parentSelectors } from "./parentsSlice"
import { employeeSelectors, getEmployees } from "./employeesSlice"


export const useSubjects = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getSubjects())
    }, [dispatch])

    const subjects = useSelector(subjectSelectors.selectAll)
    const subjectOptions = useSelector(subjectSelectors.selectIds)
    const subjectLookups = useSelector(subjectSelectors.selectEntities)
    const subjectsIsLoading = useSelector(x => x.dicts.subjects.isLoading)

    return { subjects, subjectOptions, subjectLookups, subjectsIsLoading }
}

export const useStudios = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getStudios())
    }, [dispatch])

    const studios = useSelector(studioSelectors.selectAll)
    const studioOptions = useSelector(studioSelectors.selectIds)
    const studioLookups = useSelector(studioSelectors.selectEntities)
    const studiosIsLoading = useSelector(x => x.dicts.studios.isLoading)

    return { studios, studioOptions, studioLookups, studiosIsLoading }
}


export const useGroups = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getGroups())
    }, [dispatch])

    const groups = useSelector(groupSelectors.selectAll)
    const groupOptions = useSelector(groupSelectors.selectIds)
    const groupLookups = useSelector(groupSelectors.selectEntities)
    const groupsIsLoading = useSelector(x => x.dicts.groups.isLoading)

    return { groups, groupOptions, groupLookups, groupsIsLoading }
}

export const useStudentsByGroup = group => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (group) dispatch(getStudents({ group }))
    }, [dispatch, group])

    const students = useSelector(studentSelectors.selectAll)
    const studentsIsLoading = useSelector(x => x.dicts.students.isLoading)

    return { students, studentsIsLoading }
}

export const useStudents = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getStudents())
    }, [dispatch])

    const students = useSelector(studentSelectors.selectAll)
    const studentOptions = useSelector(studentSelectors.selectIds)
    const studentLookups = useSelector(studentSelectors.selectEntities)
    const studentsIsLoading = useSelector(x => x.dicts.students.isLoading)

    return { students, studentOptions, studentLookups, studentsIsLoading }
}

export const useParents = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getParents())
    }, [dispatch])

    const parents = useSelector(parentSelectors.selectAll)
    const parentOptions = useSelector(parentSelectors.selectIds)
    const parentLookups = useSelector(parentSelectors.selectEntities)
    const parentsIsLoading = useSelector(x => x.dicts.parents.isLoading)

    return { parents, parentOptions, parentLookups, parentsIsLoading }
}


export const useEmployees = () => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getEmployees())
    }, [dispatch])

    const employees = useSelector(employeeSelectors.selectAll)
    const employeeOptions = useSelector(employeeSelectors.selectIds)
    const employeeLookups = useSelector(employeeSelectors.selectEntities)
    const employeesIsLoading = useSelector(x => x.dicts.employees.isLoading)

    return { employees, employeeOptions, employeeLookups, employeesIsLoading }
}
